import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import {ContextApi} from "../../../App"
import {formatDate} from "../../../utils/commonFunctions"

function DateField({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  // States
  const contextData = useContext(ContextApi)
  const [element, setElement] = useState({
    id:uuidv4(),
    type: "date",
    properties: {
      label: "Date Element",
      placeholder: "Enter Date Element here...",
      required: true,
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
    future : false,
    past : false
  });
  const [modal, setModal] = useState(false);

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementPlaceholderRef = useRef();
  const elementRequiredRef = useRef();
  const disableFieldRef = useRef();
  const pastRef = useRef();
  const futureRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      // previousState.properties.placeholder =
      //   elementPlaceholderRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      previousState.disableField = disableFieldRef.current.checked;
      previousState.future = futureRef.current.checked;
      previousState.past = pastRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit :!contextData.contextData.isEdit
    })
  }

  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e,element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <label>
        {element.properties.label}
        {element.properties.required && <span style={{color:'red'}}>*</span>}
      </label>
      <input
        {
          ...{
            className : "form-control",
            type : "date",
            placeholder : element.properties.placeholder,
            ...(!element.past ? null : {min : formatDate(new Date())}),
            ...(!element.future ? null : {max : formatDate(new Date())})
          }
        }

      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Date Field Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Label</label>
            <input
              ref={elementLabelRef}
              type="text"
              className="form-control"
              defaultValue={element.properties.label}
            />
          </div>
          {/* <div className="form-group">
            <label>Placeholder</label>
            <input
              ref={elementPlaceholderRef}
              type="text"
              className="form-control"
              defaultValue={element.properties.label}
            />
          </div> */}
            <div className="row mt-2 mb-4">
            <div className="col-6">
              <div className="custom-control custom-checkbox">
                <input
                  ref={pastRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="past"
                  defaultChecked={element.past}
                />
                <label className="custom-control-label" htmlFor="past">
                  Disable Past
                </label>
              </div>
            </div>
            <div className="col-6">
              <div className="custom-control custom-checkbox">
                <input
                  ref={futureRef}
                  type="checkbox"
                  className="custom-control-input"
                  id="future"
                  defaultChecked={element.future}
                />
                <label className="custom-control-label" htmlFor="future">
                  Disable Future
                </label>
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              ref={disableFieldRef}
              type="checkbox"
              className="custom-control-input"
              id="disableField"
              defaultChecked={element.disableField}
            />
            <label className="custom-control-label" htmlFor="disableField">
              Disable preFilled Field(only admin can edit)
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DateField;
